import { Status } from 'App/Components/Status/Status';
import { PatientProps, PatientResponse } from './Population.types';
import { MoreInfo } from './components/MoreInfo/MoreInfo';

export const formatRows = (employee: PatientResponse): PatientProps => {
	return {
		id: employee.id,
		employeeId: employee.employeeId,
		name: employee.name || '-',
		riskLevel: <Status status={employee.riskLevel} key={employee.riskLevel} />,
		position: employee.position,
		reference: employee.reference || '-',
		riskGroup: employee.group.name || '-',
		subRow: <MoreInfo employeeId={employee.employeeId} />,
	};
};
